import { render, staticRenderFns } from "./SectionCodeDemo.vue?vue&type=template&id=828f799a&"
import script from "./SectionCodeDemo.vue?vue&type=script&lang=js&"
export * from "./SectionCodeDemo.vue?vue&type=script&lang=js&"
import style0 from "./SectionCodeDemo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports